export const DE = {
  feature: {
    auth: {
      login: "Anmelden",
      $login: {
        title: "Melden Sie sich bei Ihrem Konto an!",
      },
      forgot_password: "Passwort vergessen",
      $forgot_password: {
        title: "Passwort vergessen?",
        message:
          "Geben Sie unten Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Code, um Ihr Passwort zurückzusetzen.",
      },
      reset_password: "Passwort zurücksetzen",
      $reset_password: {
        message:
          "Wir haben den Bestätigungscode an <b>{email}</b> gesendet. Bitte geben Sie Ihr neues Passwort ein und bestätigen Sie es unten erneut.",
        expires_in: "Der Bestätigungscode läuft in <b>{time}</b> Sekunden ab.",
        code_expired: "Code abgelaufen",
        code_expired_message:
          "Ihr Bestätigungscode ist abgelaufen. Bitte senden Sie eine neue Anfrage.",
      },
      $update_password: {
        success_message: "Ihr Passwort wurde erfolgreich aktualisiert.",
        force_message:
          "Ihr Passwort ist abgelaufen. Bitte aktualisieren Sie Ihr Passwort.",
        first_access:
          "Dies ist Ihre erste Anmeldung. Bitte ändern Sie Ihr Passwort.",
      },
      $recovery_user_password: {
        title: "Passwortwiederherstellung",
        success_message:
          "Das Verfahren zur Wiederherstellung des Passworts wurde erfolgreich abgeschlossen.\nDer Benutzer erhält eine E-Mail mit Anweisungen zum Zurücksetzen.",
        error_message:
          "Das Verfahren zur Wiederherstellung des Passworts ist fehlgeschlagen.\nBitte versuchen Sie es erneut.",
        message:
          "Senden Sie diesem Benutzer eine E-Mail mit Anweisungen zum Zurücksetzen des Passworts.",
      },
      request_support: "Support anfordern",
      $request_support: {
        message: "Füllen Sie das Formular aus, um Support anzufordern.",
        request_type: "Anfragetyp",
        $request_type: {
          1: "Ich kann mich nicht anmelden",
          2: "Die Anwendung funktioniert nicht richtig",
          3: "Ich habe eine Frage zu einer Funktion",
        },
        success_message:
          "Die Supportanfrage wurde erfolgreich gesendet.\nSie erhalten in Kürze eine Antwort.",
      },
      invitation: "Einladung",
      $invitation: {
        instructions: "Geben Sie die E-Mail-Adresse des neuen Benutzers ein und senden Sie das Formular ab. Das System sendet eine E-Mail mit Anweisungen zur Registrierung. Die Einladung ist 48 Stunden ab Versand gültig.",
        send_success_message:
          "Die Einladung wurde erfolgreich gesendet.\nDer Benutzer erhält eine E-Mail mit Anweisungen zur Annahme.",
        accept_success_message:
          "Die Einladung wurde erfolgreich angenommen.\nSie erhalten eine E-Mail mit Ihren Zugangsdaten.",
        pending_invitations:  "Ausstehende Einladungen",
        pending_invitations_message: "Die Tabelle listet alle ausstehenden Einladungen auf. Sobald ein Einladungslink abgelaufen ist, wird eine Schaltfläche angezeigt, um eine neue Einladung zu versenden.",
        resend_invitation: "Einladung erneut senden",
        invitation_expires_date: "Ablaufdatum der Einladung",
        email_address: "E-Mail-Adresse",
      },
      delete_account: "Konto löschen",
      $delete_account: {
        disclaimer:
          "Das Löschen des Kontos ist endgültig. Wenn Sie fortfahren, werden alle Ihre Daten dauerhaft entfernt. Stellen Sie sicher, dass Sie vorher alle wichtigen Informationen gesichert haben.",
        alert_message:
          "Achtung: Diese Aktion löscht Ihr Konto und alle zugehörigen Daten unwiderruflich. Wenn Sie unsicher sind, kontaktieren Sie bitte den Support.",
        success_message:
          "Ihr Konto wurde erfolgreich gelöscht. Alle Daten wurden entfernt. Vielen Dank, dass Sie unsere Plattform genutzt haben.",
        process_pending_warning: "<strong>Achtung: Der Patient {patient_full_name} hat sein Recht auf Widerruf der Einwilligung oder auf Löschung seines Kontos ausgeübt.</strong><br>Please make sure to download the patient's data using the export function available in their profile. After the grace period, all data will be permanently deleted and no longer accessible."
      },
      $withdraw_consent: {
        alert_message:
          "Wenn Sie Ihre Einwilligung widerrufen, können wir Ihre Daten nicht mehr für die vorher festgelegten Zwecke verarbeiten. Einige Funktionen sind dann möglicherweise nicht verfügbar.",
        success_message:
          "Ihre Einwilligung wurde erfolgreich widerrufen. Sie können Ihre Einstellungen jederzeit im Profil ändern.",
      },
      $download_patient_data: {
        success_message:
          "Die Patientendaten wurden erfolgreich erstellt und stehen zum Download bereit. Bitte bewahren Sie sie sicher auf und beachten Sie den Datenschutz.",
      },
    },
    therapy: {
      name: "Therapie",
      active_therapies: "Aktive Therapien | Aktive Therapie | Aktive Therapien",
      inactive_therapies:
        "Inaktive Therapien | Inaktive Therapie | Inaktive Therapien",
      prescription: "Verordnung",
      intake: {
        $status: {
          0: "Wartend",
          1: "Eingenommen",
          2: "Nicht rechtzeitig eingenommen",
          3: "Nicht eingenommen",
        },
        taken: "Eingenommen",
        taken_in_time: "Rechtzeitig eingenommen",
        taken_not_in_time: "Nicht rechtzeitig eingenommen",
        not_taken: "Nicht eingenommen",
        expected: "Erwartet",
        total: "Gesamt",
        subtotal: "Zwischensumme",
      },
      $trend_range: {
        day: "Tag",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
        $frequency: {
          day: "Täglich",
          week: "Wöchentlich",
          month: "Monatlich",
          year: "Jährlich",
        },
      },
      $range: {
        from: "Von",
        to: "Bis",
      },
      no_data: "Keine Daten erfasst",
      no_therapy_scheduled_today: "Heute keine Therapie geplant",
      no_therapy_scheduled: "Keine Therapie geplant",
      provide_therapy: "Neue Therapie hinzufügen",
      drug: "Medikament",
      prn: "PRN",
      dose: "Dosis",
      overall_adherence: "Gesamte Adhärenz",
      adherence: "Adhärenz",
      intakes_per_day:
        "{count} Mal täglich | {count} Mal täglich | {count} Mal täglich",
      add_all_prn: "Alle PRN hinzufügen",
      show_prn: "PRN anzeigen",
      daily_calendar: "Tageskalender",
    },

    home: {
      welcome_message: "Guten Morgen, {name}!",
      welcome_subtitle: "Willkommen im HCP-Portal",
      your_center: "Ihr Zentrum",
      $stats: {
        center: "Zentrumsstatistik",
        total_patients: "Gesamtzahl Patienten",
        total_caregivers: "Gesamtzahl Betreuer",
        total_hcps: "Gesamtzahl HCPs",
        centers_count: "Gesamtzahl Zentren",
        countries_count: "Beteiligte Länder",
        patients_invited_count: "Eingeladene Patienten",
        cargivers_count: "Gesamtzahl Betreuer",
        patients_activated_count: "Aktivierte Patienten",
        therapies_started_count: "Laufende Therapien",
      },
    },
    lists: {
      result_total: "Es werden <b>{count}</b> angezeigt",
      result_counts: "Es werden <b>{count}</b> von <b>{total}</b> angezeigt",
      result_count_range:
        "Es werden <b>{start}</b> - <b>{end}</b> von <b>{total}</b> angezeigt",
      out_of: "von",
    },
    surveys: {
      patient_surveys: "Befragungen",
      history: "Verlauf",
      no_surveys: "Keine Befragung eingereicht",
      treshold: "Empfohlener Schwellenwert",
      set_priority: "Priorität festlegen",
      modal_message:
        "Nach dem Festlegen kann dies bis zum Ablauf nicht deaktiviert werden.",
      typology: {
        table: "Tabelle",
        list: "Liste",
      },
      not_available_answer: "N/V",
      PDI: {
        right_eye: "Rechtes Auge",
        left_eye: "Linkes Auge",
      },
      frequency: "Frequenz",
      $frequency: {
        D: "Täglich",
        M: "Monatlich",
        Y: "Jährlich",
        O: "Einmalig",
      },
      value_representation_type: "Darstellungstyp des Wertes",
      $value_representation_type: {
        integer: "Ganzzahl",
        percentage: "Prozent",
        other: "Sonstiges",
      },
      min_value: "Minimalwert",
      max_value: "Maximalwert",
      min_label: "Beschriftung Minimalwert",
      max_label: "Beschriftung Maximalwert",
      step_increment: "Schrittweite",
      key_recommendations:
        "Geben Sie einen eindeutigen Schlüssel an, um die Befragung zu identifizieren (z. B. vorab_befragung)",
      is_notifiable: "Benachrichtigungen senden",
      default_frequency_days: "Benachrichtigungsfrequenz in Tagen",
      default_notification_time: "Benachrichtigungszeit",
      extra: "Extra (JSON-Format)",
      $steps: {
        key_recommendations:
          "Geben Sie einen eindeutigen Schlüssel an, um den Schritt zu identifizieren (z. B. schmerz_heute)",
        add: "Schritt hinzufügen",
        save: "Schritt speichern",
        delete: "Schritt löschen",
        discard_changes: "Änderungen verwerfen",
        type: "Typ",
        $type: {
          R: "Auswahl",
          T: "Text",
          V: "Wert",
          D: "Beschreibung",
          F: "Abschließen",
          VSS: "Stimmung",
          VAS: "Visuelle Analogskala",
          PDI: "Interessenspunkte",
          TS: "Zeitraum",
        },
        raw: "Rohdaten",
        editor: "Editor",
        drag_reorder:
          "Ziehen & Ablegen, um die Reihenfolge der Schritte zu ändern",
      },
      display_in_chart: "Im Diagramm anzeigen",
      chart_type: "Diagrammtyp",
      $chart_type: {
        line: "Linie",
        bar: "Balken",
        body_map: "Körperkarte",
      },
      labels: {
        bar_y_label: "Anzahl abgegebener Antworten",
      },
      required: "Erforderlich",
      include_na_option: "Option /N.V. einbeziehen",
      conditions: "Bedingungen",
      role: "Rolle",
    },
    roles: {
      type: "Typ",
      $type: {
        A: "Administrator",
        H: "HCP",
        C: "Betreuer",
        P: "Patient",
        I: "Intern",
      },
      roles_permissions: "Rollenberechtigungen",
      centers_permissions: "Zentrumsberechtigungen",
      $permissions: {
        index: "Übersicht",
        show: "Anzeigen",
        store: "Speichern",
        update: "Aktualisieren",
        destroy: "Löschen",
      },
      center_users_management: "Benutzerverwaltung",
      zone: "Zone",
      remind_policies: {
        title: "Erinnerungspolitiken",
        message:
          "Bitte denken Sie daran, die Richtlinien für die neu erstellte Rolle ({type}) festzulegen, um einen ordnungsgemäßen Zugriff und die Einhaltung sicherzustellen.",
      },
      journey_schemas: "Journey-Schemas",
      remind_journey_schemas: {
        title: "Erinnerung Journey-Schemas",
        message: "Weisen Sie diesem Rolle Journey-Schema zu, um die Patientenerfahrung basierend auf ihrer Rolle zu definieren.",
      },
    },
    contents: {
      $categories: {
        visible: "Sichtbar",
        visibility: "Sichtbarkeit",
        $visibility: {
          all: "Öffentlich",
          restricted: "Eingeschränkt",
          undefined: "",
        },
        visibility_checkbox_message:
          "Öffentliche Kategorien sind für alle Patienten sichtbar.",
        imageCover: "Titelbild",
      },
      blocks: "Blöcke",
      $blocks: {
        add: "Block hinzufügen",
        save: "Block speichern",
        delete: "Block löschen",
        discard_changes: "Änderungen verwerfen",
        type: "Typ",
        $type: {
          text: "Text",
          image: "Bild",
          video: "Video",
          html: "HTML",
        },
        raw: "Rohdaten",
        editor: "Editor",
        drag_reorder:
          "Ziehen & Ablegen, um die Reihenfolge der Blöcke zu ändern",
      },
      content_permissions: "Patienten-Inhalte",
      category: "Kategorie",
      lang: "Sprache",
      $lang: {
        en: "Englisch",
        it: "Italienisch",
        de: "Deutsch",
        fr: "Französisch",
        es: "Spanisch",
      },
    },
    consents: "Einwilligungen",
    $consents: {
      enabled_consents: "Verknüpfte Einwilligungen",
      hcp_enabled_consents: "Verknüpfte Einwilligungen mit HCPs",
      role_enabled_consents: "Verknüpfte Einwilligungen mit rolle {role}",
      update: "Wir haben unsere Datenschutzerklärung aktualisiert.",
      update_message: "Bitte lesen und akzeptieren Sie sie, um die App weiterhin nutzen zu können.",
    },
    consent: {
      draft: "Entwurf",
      version_history: "Versionsverlauf",
    },
    messages: "Nachrichten",
    $messages: {
      send: "Nachricht senden",
      select_patient_message:
        "Wählen Sie einen Patienten, um Nachrichten zu senden",
    },
    $events: {
      all_day: "Ganztägig",
    },
    $caregivers: {
      no_caregivers: "Keine Betreuer diesem Patienten zugewiesen",
    },
    $extra_fields: {
      no_choices: "Keine Optionen ausgewählt",
    },
  },
  page: {
    home: "Startseite",
    patients: "Patienten",
    patient: "Patient",
    caregivers: "Betreuer",
    add_caregiver: "Betreuer hinzufügen",
    edit_caregiver: "Betreuer bearbeiten",
    analytics: "Analysen",
    create_patient: "Neuen Patienten anlegen",
    edit_patient: "Patient bearbeiten",
    system_users: "Systembenutzer",
    invite_user: "Benutzer einladen",
    create_user: "Benutzer anlegen",
    edit_user: "Benutzer bearbeiten",
    users: "Benutzer",
    user: "Benutzer",
    centers: "Systemzentren",
    create_center: "Zentrum anlegen",
    edit_center: "Zentrum bearbeiten",
    center: "Zentrum",
    profile: "Profil",
    update_password: "Passwort aktualisieren",
    roles: "Systemrollen",
    create_role: "Rolle anlegen",
    edit_role: "Rolle bearbeiten",
    content_library: "Inhaltsbibliothek",
    contents: "Inhalte",
    content_categories: "Kategorien",
    create_content_category: "Kategorie anlegen",
    edit_content_category: "Kategorie bearbeiten",
    create_content: "Inhalt anlegen",
    edit_content: "Inhalt bearbeiten",
    consents: "Einwilligungen",
    consent: "Einwilligung",
    create_consent: "Einwilligung anlegen",
    edit_consent: "Einwilligung bearbeiten",
    consent_version: "Einwilligungsversion",
    messages: "Nachrichten",
    surveys: "Befragungen",
    create_survey: "Befragung anlegen",
    edit_survey: "Befragung bearbeiten",
    edit: "Bearbeiten",
    create: "Anlegen",
    therapy_trend: "Therapieverlauf",
    request_support: "Support anfragen",
    invitation_form: "Registrierungsformular",
    zones: "Zonen",
    delete_account: "Konto löschen",
    policies: "Richtlinien",
    create_edit_zone: "Zone erstellen / bearbeiten",
    privacy_and_cookies: "Richtlinien Datenschutz & Cookies",
    footer_link: {
      privacy_policy: "Datenschutzhinweise",
      cookie_policy: "Cookie Policy",
      terms_of_use: "Nutzungsbedingungen",
    }
  },
  cta: {
    ok: "Ok",
    login: "Jetzt anmelden",
    logout: "Abmelden",
    submit: "Senden",
    back_to_login: "Zur Anmeldung",
    view: "Anzeigen",
    view_data: "Daten anzeigen",
    hide_data: "Daten ausblenden",
    edit: "Bearbeiten",
    search: "Suchen",
    clear_filters: "Filter zurücksetzen",
    delete: "Löschen",
    $delete: {
      title: "Sind Sie sicher?",
      message: "Diese Aktion kann nicht rückgängig gemacht werden.",
    },
    delete_patient: "Patient löschen",
    delete_user: "Benutzer löschen",
    delete_center: "Zentrum löschen",
    delete_role: "Rolle löschen",
    delete_category: "Kategorie löschen",
    delete_content: "Inhalt löschen",
    delete_consent: "Einwilligung löschen",
    delete_event: "Ereignis löschen",
    delete_caregiver: "Betreuer löschen",
    delete_zone: "Zone löschen",
    confirm: "Bestätigen",
    continue: "Fortfahren",
    discard: "Verwerfen",
    stop: "Stoppen",
    $discard: {
      message: "Alle Ihre Änderungen gehen verloren.",
    },
    save: "Speichern",
    save_patient: "Patient speichern",
    save_user: "Benutzer speichern",
    save_center: "Zentrum speichern",
    save_role: "Rolle speichern",
    save_category: "Kategorie speichern",
    save_content: "Inhalt speichern",
    save_consent: "Einwilligung speichern",
    save_consent_version: "Version speichern",
    save_caregiver: "Betreuer speichern",
    save_zone: "Zone speichern",
    create: "Anlegen",
    create_patient: "Patient anlegen",
    create_user: "Benutzer anlegen",
    create_center: "Zentrum anlegen",
    create_role: "Neue Rolle anlegen",
    create_content_category: "Kategorie anlegen",
    create_content: "Inhalt anlegen",
    create_consent: "Einwilligung anlegen",
    create_consent_version: "Version anlegen",
    restore_consent_version: "Version wiederherstellen",
    publish_consent: "Version veröffentlichen",
    create_caregiver: "Betreuer anlegen",
    create_zone: "Zone anlegen",
    schedule_therapy: "Therapie planen",
    update_password: "Passwort aktualisieren",
    show_all: "Alle anzeigen",
    send: "Senden",
    add: "Hinzufügen",
    add_event: "Ereignis hinzufügen",
    edit_event: "Ereignis bearbeiten",
    save_event: "Ereignis speichern",
    add_caregiver: "Betreuer hinzufügen",
    load_more: "Mehr laden",
    next: "Weiter",
    recovery_password: "Passwort wiederherstellen",
    create_survey: "Befragung anlegen",
    save_survey: "Befragung speichern",
    delete_survey: "Befragung löschen",
    invite_user: "Benutzer einladen",
    accept_invitation: "Einladung annehmen",
    download_patient_data: "Patientendaten herunterladen",
    withdraw_consent: "Einwilligung widerrufen",
  },
  form: {
    first_name: {
      label: "Vorname",
      placeholder: "z.B. Adam",
    },
    last_name: {
      label: "Nachname",
      placeholder: "z.B. Müller",
    },
    gender: {
      label: "Geschlecht",
      0: "Unbekannt",
      1: "Männlich",
      2: "Weiblich",
      3: "Divers",
      4: "Transsexuell",
      5: "Unbekannt",
    },
    birth_date: {
      label: "Geburtsdatum",
      placeholder: "TT/MM/JJJJ",
    },
    email: {
      label: "E-Mail",
      placeholder: "z.B. adam127704@gmail.com",
    },
    otp: {
      label: "OTP-Code",
      placeholder: "Geben Sie den OTP-Code ein, der an Ihre E-Mail gesendet wurde",
    },
    password: {
      label: "Passwort",
      placeholder: "Geben Sie Ihr Passwort ein",
    },
    password_confirmation: {
      label: "Passwort bestätigen",
      placeholder: "Wiederholen Sie Ihr Passwort",
    },
    current_password: {
      label: "Aktuelles Passwort",
      placeholder: "Geben Sie Ihr aktuelles Passwort ein",
    },
    address: {
      label: "Adresse",
      placeholder: "Adresse hinzufügen",
    },
    city: {
      label: "Stadt",
      placeholder: "Stadt hinzufügen",
    },
    region: {
      label: "Region",
      placeholder: "Region hinzufügen",
    },
    zip_code: {
      label: "PLZ",
      placeholder: "Postleitzahl hinzufügen",
    },
    country: {
      label: "Land",
      placeholder: "Land hinzufügen",
    },
    location: {
      label: "Ort",
      placeholder: "Ort hinzufügen",
    },
    phone: {
      label: "Telefonnummer",
      placeholder: "z.B. +49 321 4567",
    },
    notes: {
      label: "Notizen",
      placeholder: "Zusätzliche Notizen hier eingeben",
    },
    center_id: {
      label: "Zentrum",
      placeholder: "Wählen Sie ein Zentrum",
    },
    add_caregiver: {
      label: "Betreuer hinzufügen",
    },
    section: {
      patient_information: "Patienteninformationen",
      user_information: "Benutzerinformationen",
      anagraph: "Stammdaten",
      credentials: "Zugangsdaten",
      contacts: "Kontakte",
      caregiver_information: "Betreuerinformationen",
      extra: "Weitere Angaben",
      personal_information: "Persönliche Angaben",
      department_information: "Abteilungsinformationen",
      location: "Ort",
    },
    invite_user_instructions:
      "Um Ihr Konto zu aktivieren, füllen Sie die untenstehenden Felder mit den erforderlichen Informationen aus. Nach Abschluss erhalten Sie eine E-Mail mit Ihrem temporären Passwort für den Zugriff auf die Plattform.",
    created_at: {
      label: "Erstellt am",
    },
    start_at: {
      label: "Startdatum",
    },
    end_at: {
      label: "Enddatum",
      $error: {
        therapy_range_error: "Die Therapie muss mindestens {min} Tage dauern.",
      },
    },
    name: {
      label: "Name",
    },
    title: {
      label: "Titel",
    },
    description: {
      label: "Beschreibung",
      placeholder: "Fügen Sie eine Beschreibung hinzu",
    },
    website: {
      label: "Webseite",
    },
    role: {
      label: "Rolle",
    },
    role_in_department: {
      label: "Rolle in der Abteilung",
    },
    organization: {
      label: "Organisationsname",
    },
    department: {
      label: "Abteilungsname",
    },
    main_contractor: {
      label: "Hauptkontakt",
    },
    confirmation_code: {
      label: "Bestätigungscode",
      placeholder: "Geben Sie den Bestätigungscode aus Ihrer E-Mail ein",
    },
    active: {
      label: "Aktiv",
    },
    value: {
      label: "Wert",
    },
    subtitle: {
      label: "Untertitel",
    },
    url: {
      label: "URL",
    },
    revision_number: {
      label: "Revisionsnummer",
      placeholder: "z.B. 1.2",
    },
    body: {
      label: "Inhalt",
    },
    mandatory: {
      label: "Verpflichtend",
      placeholder:
        "Geben Sie den Hinweistext an, falls der Benutzer die Zustimmung nicht erteilt",
    },
    has_checkbox: {
      label: "Checkbox für Bestätigung",
      placeholder: "Text für das Kontrollkästchen",
    },
    select_placeholder: "Option auswählen",
    select_file: "Datei auswählen",
    subject: {
      label: "Betreff",
      placeholder: "Betreff eingeben",
    },
    message: {
      label: "Nachricht",
      placeholder: "Ihre Nachricht eingeben",
    },
    type: {
      label: "Typ",
    },
    date: {
      label: "Datum",
    },
    key: {
      label: "Schlüssel",
    },
    footer: {
      label: "Fußzeile",
    },
    assignment_strategy: {
      label: "Zuweisungsstrategie",
      values: {
        by_hcp: "Durch HCP",
        by_center: "Durch Zentrum",
        self_registration: "Selbstregistrierung",
      },
    },
    is_registration_enabled: {
      label: "Patienten-Selbstregistrierung aktivieren",
    }
  },
  error: {
    something_went_wrong: "Etwas ist schiefgelaufen!",
    connection_error:
      "Die Anfrage wurde nicht gesendet oder es gab keine Antwort vom Server.\nBitte überprüfen Sie Ihre Internetverbindung.",
  },
  footer_disclaimer: {
    kareena: "",
    sifi_fk: "Alle Rechte vorbehalten - Umsatzsteuer-Identifikationsnummer 00122890874",
    fungalk: "Alle Rechte vorbehalten - Umsatzsteuer-Identifikationsnummer 00122890874",
  },
  invitation_policies: {
    terms_of_use: 'Ich habe die <a href="{url}" target="_blank">Allgemeinen Nutzungsbedingungen</a> gelesen und akzeptiere diese.',
    privacy_policy: 'Wie wir Ihre personenbezogenen Daten verarbeiten, ist in unserer <a href="{url}" target="_blank">Datenschutzerklärung</a> beschrieben.',
    cookie_policy: '<a href="{url}" target="_blank">Cookie Policy</a>.',
  },
  footer_links: {
    terms_of_use: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Nutzungsbedingungen_Arzt.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Dashboard_Terms_of_Use.pdf",
    },
    privacy_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/Karomy_Platform_Datenschutzhinweise_Arzt.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Platform_Privacy_Notice_Dashboard_Physician.pdf",
    },
    cookie_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Cookie_Policy_DE.pdf',
      fungalk: "",
    },
  },

  "France": 'Frankreich',
  "Italy": 'Italien',
  "Spain": 'Spanien',
  "United Kingdom": 'Vereinigtes Königreich',
  "Germany": 'Deutschland',
};
